/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Projects_Delete_Confirm_DescriptionInputs */



/**
* | output |
* | --- |
* | "Are you sure you want to delete \"{name}\"? This action cannot be undone and all associated chats will be permanently deleted." |
*
* @param {Projects_Delete_Confirm_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const projects_delete_confirm_description = /** @type {((inputs: Projects_Delete_Confirm_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Projects_Delete_Confirm_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Möchtest du "${i?.name}" wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden und alle zugehörigen Chats werden dauerhaft gelöscht.`)
	return /** @type {LocalizedString} */ (`Are you sure you want to delete "${i?.name}"? This action cannot be undone and all associated chats will be permanently deleted.`)
});